import styled, { css } from "styled-components";
import { flexbox, FlexboxProps, space, SpaceProps } from "styled-system";

export const Flex = styled.div<FlexboxProps & { gap?: string }>`
  display: flex;
  ${flexbox}
  ${({ gap }) =>
    gap &&
    css`
      gap: ${gap};
    `}
`;

export const Box = styled.div<SpaceProps>`
  ${space}
`;
